module.exports = __webpack_public_path__ + "media/images/area/feature/setouchi/related/en/2-e6ef2e6e120bddd5a7a6085106a0cec4.jpg";